<template>
  <v-row>
    <v-col cols="4">
      <v-card>
        <v-toolbar color="transparent" flat height="55">
          <img class="mr-2" :src="require(`@/assets/appIcon-apps--CustomerBase.svg`)" width="18">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">
            <router-link :to="{name: 'BaseList'}" class="subtitle-1 routerLink font-weight-medium">Customer Base</router-link>
          </v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="pr-2">
              <v-btn :to="{ name: 'BaseUpdate', params: { id: instance.id } }" outlined retain-focus-on-click>Editar</v-btn>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="py-0 background overflow-y-auto" style="height: calc(100vh - 238px)">
          <v-row class="fill-height">
            <v-col cols="12" class="px-0 fill-height overflow-y-auto">
              <v-skeleton-loader class="transparent" v-if="$store.state.apps.retrieveLoader" type="list-item-three-line, list-item-three-line" />

              <template v-else>
                <!-- basic -->
                <v-list class="transparent">
                  <v-list-item>
                    <v-list-item-title class="text--secondary subtitle-1 font-weight-medium">Información general</v-list-item-title>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-title>Nombre</v-list-item-title>
                    <v-list-item-subtitle>{{instance.name}}</v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-title>ID</v-list-item-title>
                    <v-list-item-subtitle>
                      <v-tooltip color="primary" right transition="scale-transition">
                        <template v-slot:activator="{on}">
                          <v-btn class="font-weight-regular" @click="toClipboard(instance.id)" text color="secondary" v-on="on" :ripple="false">{{instance.id}}</v-btn>
                        </template>
                        <span class="white--text">Copiar</span>
                      </v-tooltip>
                    </v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-title>Creado el</v-list-item-title>
                    <v-list-item-subtitle>{{instance.created | dateTime}}</v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-title>Última actualización el</v-list-item-title>
                    <v-list-item-subtitle>{{instance.updated | dateTime}}</v-list-item-subtitle>
                  </v-list-item>
                </v-list>
                <!-- end basic -->

                <!-- features -->
                <v-list class="mt-8 transparent">
                  <v-list-item>
                    <v-list-item-title class="text--secondary subtitle-1 font-weight-medium">Funcionalidades</v-list-item-title>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-title>Administrar información de facturación</v-list-item-title>
                    <v-list-item-action>
                      <v-icon color="primary" v-if="instance.manage_billing">mdi-check-circle</v-icon>
                      <v-icon color="secondary" v-else>mdi-minus-circle</v-icon>
                    </v-list-item-action>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-title>Cancelar suscripción</v-list-item-title>
                    <v-list-item-action>
                      <v-icon color="primary" v-if="instance.cancel_subscription">mdi-check-circle</v-icon>
                      <v-icon color="secondary" v-else>mdi-minus-circle</v-icon>
                    </v-list-item-action>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-title>Administrar tarjeta</v-list-item-title>
                    <v-list-item-action>
                      <v-icon color="primary" v-if="instance.manage_source">mdi-check-circle</v-icon>
                      <v-icon color="secondary" v-else>mdi-minus-circle</v-icon>
                    </v-list-item-action>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-title>Visualizar facturación y pagos</v-list-item-title>
                    <v-list-item-action>
                      <v-icon color="primary" v-if="instance.display_invoices">mdi-check-circle</v-icon>
                      <v-icon color="secondary" v-else>mdi-minus-circle</v-icon>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
                <!-- end features -->

                <!-- auth -->
                <v-list class="mt-8 transparent">
                  <v-list-item>
                    <v-list-item-title class="text--secondary subtitle-1 font-weight-medium">Autenticación</v-list-item-title>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-title v-if="instance.auth_scheme === 'email'">Autenticación con email a través de Piriod</v-list-item-title>
                    <v-list-item-title v-else>Integrado con una autenticación existente</v-list-item-title>
                  </v-list-item>
                </v-list>
                <!-- end auth -->
              </template>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4">
          <span class="red--text body-2 font-weight-medium">Zona de peligro</span>
          <v-spacer />
          <v-btn @click="destroyBase" outlined color="red" :ripple="false"><v-icon left size="18">mdi-delete</v-icon>Eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
    <v-col cols="8">
      <v-card class="pa-0">
        <v-card-title class="pa-0">
          <v-toolbar color="transparent" flat height="55">
            <v-icon color="secondary" left size="18">mdi-tools</v-icon>
            <v-toolbar-title class="subtitle-1 text--secondary font-weight-medium">Instalación</v-toolbar-title>
          </v-toolbar>
          <v-spacer />
          <v-toolbar-items>
            <v-row class="mr-1" align="center" justify="end">
              <span class="body-2 text--primary font-weight-regular">Modo de prueba</span><v-switch class="pt-0 mt-0 mx-3" v-model="editableTestMode.test_mode" @change="updateTestMode" hide-details :loading="$store.state.apps.createLoader" />
            </v-row>
          </v-toolbar-items>
        </v-card-title>
        <v-divider />
        <v-card-title class="pa-0">
          <v-tabs v-model="tabsSetup" color="primary" height="55" slider-size="2" grow>
            <v-tab class="text-none font-weight-medium" :ripple="false">Sin código</v-tab>
            <v-tab class="text-none font-weight-medium" :ripple="false">Con código</v-tab>
          </v-tabs>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-0 background overflow-y-auto" style="height: calc(100vh - 295px)">
          <v-tabs-items class="transparent" v-model="tabsSetup">
            <v-tab-item transition="fade-transition" reverse-transition="fade-transition">
              <v-skeleton-loader class="transparent" v-if="$store.state.apps.retrieveLoader" type="list-item-three-line, list-item-three-line, list-item-three-line" />

              <template v-else>
                <v-row class="px-4 py-2">
                  <v-col cols="3">
                    <span class="d-block py-2 body-2 text--primary">Configuración de la página</span>
                  </v-col>
                  <v-col cols="8">
                    <v-list class="transparent">
                      <v-list-item class="mt-1">
                        <v-list-item-title class="mb-1 body-2 text--secondary font-weight-medium">Habilitar página</v-list-item-title>
                        <v-list-item-subtitle>
                          <v-switch class="mt-n4" style="position:absolute" v-model="editableHostedPageEnable.enable_hosted" @change="updateHostedPageEnable" />
                        </v-list-item-subtitle>
                      </v-list-item>
                      <v-list-item v-if="editableHostedPageEnable.enable_hosted">
                        <v-list-item-content class="py-2">
                          <v-tooltip color="primary" dark max-width="280" top transition="scale-transition">
                            <template v-slot:activator="{on}">
                              <v-text-field v-on="on" :value="`${$PAY_BASE}/hosted/customer_base/${instance.publishable_key}`" @click="toClipboard(`${$PAY_BASE}/hosted/customer_base/${instance.publishable_key}`)" background-color="white" dense height="36" outlined readonly single-line hide-details>
                                <template v-slot:append>
                                  <v-btn class="px-3" :href="`${$PAY_BASE}/hosted/customer_base/${instance.publishable_key}`" target="_blank" height="18" text color="primary" :ripple="false">Ir a la página<v-icon right>mdi-open-in-new</v-icon></v-btn>
                                </template>
                              </v-text-field>
                            </template>
                            <span class="white--text">Copiar</span>
                          </v-tooltip>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item two-line>
                        <v-list-item-content>
                          <v-list-item-title class="mb-1 body-2 text--secondary font-weight-medium">Layout</v-list-item-title>
                          <v-list-item-subtitle>
                            <v-row class="mx-0">
                              <v-col cols="4" v-for="d in hostedPageLayouts" :key="d">
                                <v-sheet @click="editableHostedPage.hosted_page_layout = d" style="cursor: pointer">
                                  <v-radio-group v-model="editableHostedPage.hosted_page_layout" :mandatory="false" class="py-0 mt-0 rounded" style="border: 1px solid #D8E0EA" hide-details>
                                    <v-img class="rounded-t" cover :aspect-ratio="1" :src="require(`@/assets/appAsset-HostedPages--Layout-${d}.svg`)" />
                                    <v-radio class="pa-2" :value="d" :label="d" />
                                  </v-radio-group>
                                </v-sheet>
                              </v-col>
                            </v-row>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-col>
                </v-row>
                <v-row class="px-4 py-2">
                  <v-col cols="3">
                    <span class="d-block py-4 body-2 text--primary">Encabezado</span>
                  </v-col>
                  <v-col cols="8">
                    <v-list class="transparent">
                      <v-list-item two-line>
                        <v-list-item-content>
                          <v-list-item-title>
                            <span class="d-block mb-1 body-2 text--secondary font-weight-medium">Título</span>
                            <span class="d-block mb-2 text--primary">Personaliza los mensajes que se muestran a los clientes en la página.</span>
                          </v-list-item-title>
                          <v-list-item-subtitle>
                            <v-text-field v-model.trim="$v.editableHostedPage.hosted_page_title.$model" :error="$v.editableHostedPage.hosted_page_title.$error" maxlength="32" background-color="white" height="36" outlined required single-line dense hide-details />
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item two-line>
                        <v-list-item-content>
                          <v-list-item-title class="body-2 text--secondary font-weight-medium">Descripción</v-list-item-title>
                          <v-list-item-subtitle>
                            <v-textarea v-model.trim="$v.editableHostedPage.hosted_page_description.$model" :error="$v.editableHostedPage.hosted_page_description.$error" background-color="white" outlined hide-details />
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-col>
                </v-row>
                <v-row class="px-4 py-2">
                  <v-col cols="3">
                    <span class="d-block py-4 body-2 text--primary">Navegación</span>
                  </v-col>
                  <v-col cols="8">
                    <v-list class="transparent">
                      <v-list-item class="mt-1">
                        <v-list-item-content>
                          <v-list-item-title>
                            <span class="d-block mb-1 body-2 text--secondary font-weight-medium">Items del menú</span>
                            <span class="d-block text--primary">Agrega enlances para el menú de navegación de la página.</span>
                          </v-list-item-title>
                          <v-list-item-subtitle>
                            <template v-if="editableHostedPage.menu_items.length">
                              <v-row class="mx-0 mt-3">
                                <v-col class="py-0 px-1" cols="3">
                                  <span class="body-2 text--secondary font-weight-medium">Etiqueta</span>
                                </v-col>
                                <v-col class="py-0 px-1" cols="6">
                                  <span class="body-2 text--secondary font-weight-medium">URL</span>
                                </v-col>
                              </v-row>
                              <v-row class="mx-0" align="center" v-for="(d, i) in editableHostedPage.menu_items" :key="i">
                                <v-col class="pa-0" cols="3">
                                  <v-text-field v-model.trim="$v.editableHostedPage.menu_items.$each[i].label.$model" :error="$v.editableHostedPage.menu_items.$each[i].label.$error" maxlength="18" background-color="white" height="36" outlined required single-line dense hide-details />
                                </v-col>
                                <v-col class="pa-0" cols="8">
                                  <v-text-field v-model.trim="$v.editableHostedPage.menu_items.$each[i].url.$model" :error="$v.editableHostedPage.menu_items.$each[i].url.$error" maxlength="64" background-color="white" height="36" outlined required single-line dense hide-details />
                                </v-col>
                                <v-col class="pa-0 text-center" cols="1">
                                  <v-btn @click="editableHostedPage.menu_items.splice(i, 1)" min-width="20" max-width="20" min-height="28" max-height="28" text color="red" :ripple="false"><v-icon size="20">mdi-delete</v-icon></v-btn>
                                </v-col>
                              </v-row>
                            </template>
                            <v-row class="mx-0">
                              <v-col class="pa-0">
                                <v-btn @click="addMenuItem" text color="primary" :ripple="false"><v-icon left>mdi-plus</v-icon>Agregar item de menú</v-btn>
                              </v-col>
                            </v-row>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-col>
                </v-row>
                <v-row class="px-4 py-2">
                  <v-col cols="3">
                    <span class="d-block py-4 body-2 text--primary">Vínculos</span>
                  </v-col>
                  <v-col cols="8">
                    <v-list class="transparent">
                      <v-list-item class="mt-1" two-line>
                        <v-list-item-content>
                          <v-list-item-title>
                            <span class="d-block mb-1 body-2 text--secondary font-weight-medium">Términos de uso</span>
                          </v-list-item-title>
                          <v-list-item-subtitle>
                            <v-text-field v-model.trim="$v.editableHostedPage.terms_of_service_url.$model" :error="$v.editableHostedPage.terms_of_service_url.$error" maxlength="64" background-color="white" height="36" outlined required single-line dense hide-details />
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                      <v-list-item two-line>
                        <v-list-item-content>
                          <v-list-item-title class="body-2 text--secondary font-weight-medium">Política de privacidad</v-list-item-title>
                          <v-list-item-subtitle>
                            <v-text-field v-model.trim="$v.editableHostedPage.privacy_policy_url.$model" :error="$v.editableHostedPage.privacy_policy_url.$error" maxlength="64" background-color="white" height="36" outlined required single-line dense hide-details />
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-col>
                </v-row>
              </template>
            </v-tab-item>
            <v-tab-item transition="fade-transition" reverse-transition="fade-transition">
              <v-row class="px-4 py-2">
                <v-col md="12">
                  <span class="d-block mt-2">Copia y pega este fragmento de código antes de la etiqueta <code class="background text--secondary">&lt;/body&gt;</code> en todas las páginas en las que deseas que este portal de cliente aparezca para tu usuario.</span>
                </v-col>
                <v-col md="12">
                  <v-sheet outlined rounded>
                    <pre v-highlightjs="snippet"><code class="rounded white html"></code></pre>
                  </v-sheet>
                </v-col>
                <v-col cols="12">
                  <span>Usa la <v-btn class="mt-n1 text-decoration-underline font-weight-medium" color="primary" :href="`${$DOCS_BASE}${guide}`" target="_blank" text>guía de instalación</v-btn> para configurar tu portal de cliente</span>
                </v-col>
              </v-row>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4">
          <v-spacer />
          <v-btn v-if="tabsSetup === 0" @click="updateHostedPage" :loading="$store.state.apps.createLoader" color="primary">Guardar</v-btn>
          <v-btn v-if="tabsSetup === 1" @click="toClipboard(snippet)" color="primary"><v-icon left small>mdi-clipboard</v-icon>Copiar código</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import { maxLength, required, url } from 'vuelidate/lib/validators'
import { cloneDeep } from 'lodash'

import GenericViewMixin from '@/mixins/GenericViewMixin'

export default {
  mixins: [
    GenericViewMixin
  ],
  data: () => ({
    editableHostedPage: {
      menu_items: [],
      hosted_page_description: '',
      hosted_page_layout: '',
      hosted_page_title: '',
      privacy_policy_url: '',
      terms_of_service_url: ''
    },
    editableHostedPageEnable: {
      enable_hosted: true
    },
    editableTestMode: {
      test_mode: false
    },
    guide: '/docs/apps-customer_base#instalación',
    hostedPageLayouts: ['vertical', 'horizontal'],
    snippet: '',
    tabsSetup: 0
  }),
  computed: mapState({
    instance: state => state.apps.basesDetail
  }),
  created () {
    this.$store.dispatch('apps/RETRIEVE', {
      resource: 'customer_base/bases',
      id: this.$route.params.id
    })
    .then(() => {
      const clone = cloneDeep(this.instance)

      Object.keys(this.editableHostedPage).forEach(k => {
        this.editableHostedPage[k] = clone[k]
      })

      Object.keys(this.editableHostedPageEnable).forEach(k => {
        this.editableHostedPageEnable[k] = clone[k]
      })

      Object.keys(this.editableTestMode).forEach(k => {
        this.editableTestMode[k] = clone[k]
      })
    })
    .then(() => {
      this.snippet = `
      <div id="piriod-widget"></div>

      <script>
        window.piriodSettings = {
          service: "customerBase",
          customerBaseId: "${this.instance.publishable_key || ''}",
          sessionKey: "session token (required if use existing authentication)"
        };
        (function () { var s=document.createElement("script"); s.src="${process.env.VUE_APP_JS_BASE}/embed/piriod-embed.umd.min.js"; s.async=true; s.type="text/javascript"; var x=document.getElementsByTagName("script")[0]; x.parentNode.insertBefore(s, x); })();
      <\/script>
      `
    })
  },
  methods: {
    addMenuItem () {
      this.editableHostedPage.menu_items.push({
        label: '',
        url: ''
      })
    },
    destroyBase () {
      this.$dialog.warning({
        title: 'Eliminar',
        text: `
          <span class="d-block mb-4">No se seguirá mostrando este portal de cliente en los lugares que esté publicado.</span>
          <span class="d-block mb-4">¿Estás seguro de continuar?</span>
          <span class="d-block font-weight-medium">Esta acción no se puede deshacer</span>
        `,
        actions: [
          {
            color: 'red',
            text: 'Continuar',
            handle: () => {
              this.$store.dispatch('apps/DESTROY', {
                resource: 'customer_base/bases',
                id: this.instance.id
              })
              .then(() => {
                this.$router.push({
                  name: 'BaseList'
                })
              })
              .catch((error) => {
                this.$dialog.message.error(this.parseErrors(error.response.data))
              })
            }
          }
        ]
      })
    },
    updateTestMode () {
      this.$store.dispatch('apps/UPDATE', {
        resource: 'customer_base/bases',
        id: this.instance.id,
        payload: {
          test_mode: this.editableTestMode.test_mode
        }
      })
    },
    updateHostedPage () {
      this.$v.editableHostedPage.$touch()

      if (this.$v.editableHostedPage.$invalid) {
        return false
      }

      this.$store.dispatch('apps/UPDATE', {
        resource: 'customer_base/bases',
        id: this.$route.params.id,
        payload: this.editableHostedPage
      })
      .then(() => {
        this.$dialog.message.info('Preferencias actualizadas.')
      })
      .catch((error) => {
        this.$dialog.message.error(this.parseErrors(error.response.data))
      })
    },
    updateHostedPageEnable () {
      this.$store.dispatch('apps/UPDATE', {
        resource: 'customer_base/bases',
        id: this.$route.params.id,
        payload: this.editableHostedPageEnable
      })
      .then(() => {
        this.$dialog.message.info('Preferencias actualizadas.')
      })
      .catch((error) => {
        this.$dialog.message.error(this.parseErrors(error.response.data))
      })
    }
  },
  validations: {
    editableHostedPage: {
      hosted_page_description: {
        maxLength: maxLength(256)
      },
      hosted_page_title: {
        maxLength: maxLength(32)
      },
      menu_items: {
        $each: {
          label: {
            required
          },
          url: {
            required,
            url
          }
        },
        maxLength: maxLength(6)
      },
      privacy_policy_url: {
        url
      },
      terms_of_service_url: {
        url
      }
    }
  }
}
</script>